import { useMutation, useQuery } from 'react-query';
import { SizeType } from './models/size-type.model';
import { TreatmentType } from './models/treatment-type.model';
import { treatmentTypeService } from '../services/treatment-types.service';

export function useTreatmentTypeQuery() {
    return useQuery<SizeType[]>(["size-types"], () =>
        treatmentTypeService.getAllActive(), {
            select: (arr) => [...arr].sort((a,b)=> (a as any).name.localeCompare((b as any).name, 'pl'))
        });
}

export function useActiveTreatmentTypesAsSelectOptionQuery() {
    return useQuery(
        ["treatment-types", "treatment-types-options"],
        () => treatmentTypeService.getAllActiveAsOptions(), {
            select: (arr: any[]) => [...arr].sort((a,b)=> (a.label ?? '').toString().localeCompare((b.label ?? '').toString(), 'pl'))
        }
    )
}

export function useAddTreatmentTypeMutation() {
    return useMutation((request: TreatmentType) => treatmentTypeService.add(request));
}

export function useEditTreatmentTypeMutation() {
    return useMutation((request: TreatmentType) => treatmentTypeService.edit(request));
}

export function useDeleteTreatmentTypeMutation() {
    return useMutation((id: number) => treatmentTypeService.delete(id));
}